module.exports = __webpack_public_path__ + "img/deposit.f1d144ab.png";